import { RightOutlined, SearchOutlined, DownloadOutlined, BankOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, Space, Collapse, Table, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import { PRINT_BASE_URL, CLUB_AFFILIATION_REPORT_XLS_URL } from "../../utility/URL";

import commonService from "../../api/common.service";
import AllReceiptView from "../../components/report/AllReceiptView";
import clubService from "../../api/clubaffiliation.service";
import CustomTableSearch from "../../components/common/CustomTableSearch";
const { Option } = Select;
const { Panel } = Collapse;
const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth(),
    receipt_end_date: commonUtility.lastDateOfMonth(),
    member_id: "",
};



const ClubAffiliationReport = () => {
    const [form] = Form.useForm();



    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [programmeList, setProgrammeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);

    const [afilliationStartYear, setAfilliationStartYear] = useState([]);
    const [afilliationEndYear, setAfilliationEndYear] = useState([]);
    const [filteredSearchList, setFilteredSearchList] = useState([]);


    const columns = [
        {
            title: 'Name',
            dataIndex: 'club_name',
            key: 'club_name',
            render: (val, data) => (<>
                <p style={{ fontWeight: 'bold' }}>{data.club_name}</p>
            </>)

        },
        {
            title: 'Starting Affiliation Year',
            dataIndex: 'club_affiliation_start',
            key: 'club_affiliation_start',
            render: (val, data) => (<>
                <p style={{ fontWeight: 'bold' }}>{data.club_affiliation_start}</p>
            </>)

        },
        {
            title: 'Address',
            dataIndex: 'club_address',
            key: 'club_address',
            width: 250,
            render: (val, data) => (<>
                <p style={{ fontWeight: 'bold' }}>{data.club_address}</p>
            </>)
        },
        {
            title: 'Payment Information',
            dataIndex: 'totalPaid',
            key: 'totalPaid',
            render: (val, data) => {
                const outstandingBalance = calculateOutstandingBalance(data.affiliationData, data.current_year);
                const totalPaid = calculateTotalPaid(data.affiliationData, data.current_year);
                const advancePaymentDone = calculateAdvancePaymentDone(data.affiliationData, data.current_year);

                return (
                    <>

                        <p style={{ fontWeight: 'bold' }}>
                            <Tag color="magenta" style={{ margin: 1 }}>{`Outstanding : ${outstandingBalance}`}</Tag>
                            <Tag color="blue" style={{ margin: 1 }}>{`Total Paid: ${totalPaid}`}</Tag>
                            <Tag color="green" style={{ margin: 4 }}>{`Advance Payment : ${advancePaymentDone}`}</Tag>
                        </p>

                    </>
                );
            },
        },
    ];


    const expandedRowRender = (data) => {



        const detailColumns = [
            {
                title: 'Year',
                dataIndex: 'year',
                //dataIndex: ['ratio_name'],
                key: 'year',
                render: (val, data) => (<>
                    {data.is_current_year == "Y" ? <><p style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{data.year}</p></> : <><p style={{ fontWeight: 'normal' }}>{data.year}</p></>}

                </>)
            },
            {
                title: 'Receipt No',
                dataIndex: 'receipt_no',
                //dataIndex: ['ratio_name'],
                key: 'receipt_no',


            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                //dataIndex: ['ratio_name'],
                key: 'amount',
            },
        ];


        const detailDatas = [];
        for (let i = 0; i < data.affiliationData.length; ++i) {
            detailDatas.push({
                key: commonUtility.randomID(),
                year: data.affiliationData[i].year,
                receipt_no: data?.affiliationData[i]?.paymentData[0]?.receipt_no,
                amount: data?.affiliationData[i]?.paymentData[0]?.amount,
                is_current_year: data.current_year == data.affiliationData[i].year ? "Y" : "N",
                //amount: 500,
            });
        }

        console.log('detailDatas');

        return <Table columns={detailColumns} dataSource={detailDatas} pagination={false} />;
    };


    const onReportSearch = async (values) => {
        console.log('values', values);
        setReportList([])

        const formdValues = {
            start_affiliation_year_id: values.start_affiliation_year_id == undefined ? 0 : values.start_affiliation_year_id,
            end_affiliation_year_id: values.end_affiliation_year_id == undefined ? 0 : values.end_affiliation_year_id,
        }

        const data = { formdata: formdValues };

        clubService.clubFeeHistoryReport(data).then((res) => {

            if (res.data.response_status == SUCCESS_STATUS) {
                //  let formatted_data = ConvertedData(res.data);
                console.log('res.data', res.data);
                setReportList(res.data.response_data);
                setFilteredSearchList(res.data.response_data);
            }
            else {
                setReportList([])
            }
            setIsDataUpdated(!isDataUpdated)
        });
    };


    const onChange = (key) => {
        console.log(key);
    };


    const calculateOutstandingBalance = (affiliationData, currentYear) => {
        let outstandingBalance = 0;

        affiliationData.forEach((data) => {
            if (data.year <= currentYear && data.paymentData.length === 0) {
                outstandingBalance += data.year_amount;
            }
        });

        return outstandingBalance;
    };

    const calculateTotalPaid = (affiliationData, currentYear) => {
        let totalPaid = 0;

        affiliationData.forEach((data) => {
            if (data.year <= currentYear && data.paymentData.length > 0) {
                totalPaid += data.paymentData[0].amount;
            }
        });

        return totalPaid;
    };

    const calculateAdvancePaymentDone = (affiliationData, currentYear) => {
        let advancePaymentDone = 0;

        affiliationData.forEach((data) => {
            if (data.year > currentYear && data.paymentData.length > 0) {
                advancePaymentDone += data.paymentData[0].amount;
            }
        });

        return advancePaymentDone;
    };


    useEffect(() => {
        clubService.clubYearList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setProgrammeList(res.data.response_data);
                setAfilliationStartYear(res.data.response_data);
                setAfilliationEndYear(res.data.response_data);
            }
        });

    }, []);


    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = reportList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
    }

    const handleExport = () => {
        form.validateFields(['start_affiliation_year_id', 'end_affiliation_year_id'])
            .then(formValues => {
                if (formValues.start_affiliation_year_id > formValues.end_affiliation_year_id) {
                    form.setFields([{
                        name: 'start_affiliation_year_id',
                        errors: ['Start year cannot be greater than end year']
                    }]);
                    return;
                }

                const exportUrl = `${PRINT_BASE_URL}gstregister/club_receipt_excel/${formValues.start_affiliation_year_id == undefined ? 0 : formValues.start_affiliation_year_id}/${formValues.end_affiliation_year_id == undefined ? 0 : formValues.end_affiliation_year_id}`;
                window.open(exportUrl, "_blank");
            })
            .catch(() => {
                // Form validation will show errors below dropdowns automatically
            });
    };

    const handlePendingExport = () => {
        form.validateFields(['start_affiliation_year_id', 'end_affiliation_year_id'])
            .then(formValues => {
                if (formValues.start_affiliation_year_id > formValues.end_affiliation_year_id) {
                    form.setFields([{
                        name: 'start_affiliation_year_id',
                        errors: ['Start year cannot be greater than end year']
                    }]);
                    return;
                }

                const exportUrl = `${PRINT_BASE_URL}gstregister/club_receipt_excel_unpaid/${formValues.start_affiliation_year_id == undefined ? 0 : formValues.start_affiliation_year_id}/${formValues.end_affiliation_year_id == undefined ? 0 : formValues.end_affiliation_year_id}`;
                window.open(exportUrl, "_blank");
            })
            .catch(() => {
                // Form validation will show errors below dropdowns automatically
            });
    };

    const handleExcelExport = () => {
        const exportUrl = CLUB_AFFILIATION_REPORT_XLS_URL;
        window.open(exportUrl, "_blank");
    }

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Club Affiliation Report"
                        subTitle=""
                        extra={[
                            <Button
                                key="1"
                                style={{
                                    backgroundColor: "#feba12",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "5px",
                                }}
                                size="medium"
                                icon={<BankOutlined />}
                                onClick={handleExcelExport}
                            >
                                Get Payment Status
                            </Button>

                        ]}

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >

                                        <Col xs={6} xl={4}>
                                            <Form.Item
                                                name="start_affiliation_year_id"
                                                label="Financial Year From">
                                                <Select className="text-left" defaultValue={1}>
                                                    {/* <Option value="">Select</Option> */}
                                                    {afilliationStartYear.length > 0
                                                        ? afilliationStartYear.map((start_year_obj) => (
                                                            <Option
                                                                key={start_year_obj.affiliation_year_id}
                                                                value={start_year_obj.affiliation_year_id}
                                                            >
                                                                {`${start_year_obj.start_year} - ${start_year_obj.end_year}`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={6} xl={4}>
                                            <Form.Item
                                                name="end_affiliation_year_id"
                                                label="Financial Year To"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Select upto year',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left">
                                                    <Option value="">Select</Option>
                                                    {afilliationEndYear.length > 0
                                                        ? afilliationEndYear.map((end_year_obj) => (
                                                            <Option
                                                                key={end_year_obj.affiliation_year_id}
                                                                value={end_year_obj.affiliation_year_id}
                                                            >
                                                                {`${end_year_obj.start_year} - ${end_year_obj.end_year}`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>


                                        <Col xs={24} xl={1}>
                                            <Form.Item
                                                label=" "
                                                style={{
                                                    marginBottom: 24,
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    height: '100%'
                                                }}
                                            >
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={4}>
                                            <Form.Item
                                                label=" "
                                                style={{
                                                    marginBottom: 24,
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    height: '100%'
                                                }}
                                            >
                                                <Button
                                                    shape="round"
                                                    htmlType="button"
                                                    className="custom-button-green"
                                                    onClick={handleExport}
                                                >
                                                    Affiliated Excel <DownloadOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={3}>
                                            <Form.Item
                                                label=" "
                                                style={{
                                                    marginBottom: 24,
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    height: '100%'
                                                }}
                                            >
                                                <Button
                                                    shape="round"
                                                    htmlType="button"
                                                    className="custom-button-green"
                                                    onClick={handlePendingExport}
                                                >
                                                    Outstanding <DownloadOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>




                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        <div className='tableView'>
                            <div className="form-content">
                                {/* <AllReceiptView reportList={reportList} isDataUpdatedValue={isDataUpdated} /> */}

                                {
                                    reportList.length > 0 ? <>
                                        <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                                        <div className="nestedTable">
                                            <Table
                                                columns={columns}
                                                rowKey={list => list.club_id}
                                                //dataSource={reportList}
                                                dataSource={filteredSearchList}
                                                expandable={{
                                                    expandedRowRender: (record) => expandedRowRender(record),
                                                    defaultExpandedRowKeys: ['0'],
                                                }}
                                                size="small"
                                            />
                                        </div>

                                    </> : <></>
                                }


                            </div>
                        </div>




                    </div>

                </div>
            </div>

        </div>


    )
}

export default ClubAffiliationReport